module.exports = __webpack_public_path__ + "img/24.95e0b95b.png";